import { Box } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { SystemSwitch } from "../../components/UIToolkit/Clickable/SystemSwitch";
import { InfoIconWithTooltip } from "../../components/UIToolkit/molecules/InfoIconWithTooltip";

interface HideColumnNamesSettingProps {
	isDetailed: boolean;
	hideColumnNames: boolean;
	onHideColumnNamesChange: (enabled: boolean) => void;
}

/** Detailed-only "Don't show column names" toggle, in the same switch + ⓘ form as its Additional Settings neighbours. */
export const HideColumnNamesSetting: FC<HideColumnNamesSettingProps> = ({ isDetailed, hideColumnNames, onHideColumnNamesChange }) => {
	const { t } = useTranslation();
	if (!isDetailed) return null;

	return (
		<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
			<SystemSwitch
				dataTestId="printout-hide-column-names-switch"
				checked={hideColumnNames}
				onChange={() => onHideColumnNamesChange(!hideColumnNames)}
				label={t("printout.hide.column.names")}
				// The longest label in the column: unwrapped, it pushes the settings panel wider than its column.
				labelWrap
			/>
			<InfoIconWithTooltip dataTestId="printout-hide-column-names-info" title={t("printout.hide.column.names.description")} />
		</Box>
	);
};
